import { render, staticRenderFns } from "./SegmentSourceLinker.vue?vue&type=template&id=18c5aef4&scoped=true&"
import script from "./SegmentSourceLinker.vue?vue&type=script&lang=js&"
export * from "./SegmentSourceLinker.vue?vue&type=script&lang=js&"
import style0 from "./SegmentSourceLinker.vue?vue&type=style&index=0&id=18c5aef4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c5aef4",
  null
  
)

export default component.exports